import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import actionCreator from "../../../redux/action/actionCreator";

// core-components

import Toast from "../../../components/MessageToast";
import CreateForm from "../../components/forms/JobsForm";
import { CREATE_JOB, UPDATE_JOB } from "../../../redux/jobs/types";
import Loading from "../../../components/isLoading";
import { toast } from "react-toastify";
import BreadCrumps from "../../../components/BreadCrups";
import { fetchJobData } from "../../../redux/jobs";
import { useNavigate } from "react-router";

export default (props) => {
  const { jobId } = props;
  const dispatch = useDispatch();

  const operationStore = useSelector((store) =>
    jobId ? store.updateJobGlobalStore : store.createJobGlobalStore
  );
  const [state, setState] = useState({
    openToast: false,
  });
  const jobData = useSelector((state) => state.jobGlobalStore);

  const openToast = ({ message, type, onClose }) =>
    Toast({ message, type, duration: 3000, onClose });

  useEffect(() => {
    if (jobId && jobId !== jobData.data.id) {
      dispatch(fetchJobData(jobId));
    }
  }, []);

  const handleFormSubmit = async (formData) => {
    const { title, location, fileUrl, deadline } = formData;
    if ((!title, !location, !fileUrl, !deadline)) {
      return openToast({
        message: "Please Enter All required fields",
        type: "warning",
      });
    }
    const jobInfo = {
      title,
      location,
      deadline,
      pdfUrl: fileUrl || "",
      authorId: "",
    };
    await toast.promise(
      dispatch(
        actionCreator({
          method: jobId ? "PATCH" : "POST",
          path: jobId ? `/api/jobs/${jobId}` : "/api/jobs",
          actionType: jobId ? UPDATE_JOB : CREATE_JOB,
          data: jobInfo,
        })
      ),
      {
        pending: `${!jobId ? "Creating" : "Updating"} job`,
      }
    );

    setState({ ...state, openToast: true });
  };
  const navigate = useNavigate();

  if (operationStore.message && state.openToast) {
    Toast({
      message: operationStore.message,
      type: operationStore.message.includes("successful") ? "success" : "error",
      onClose: () =>
        operationStore.message.includes("successful") ? navigate(-1) : null,
    });

    setState({ ...state, openToast: false });
  }

  const crumps = [
    {
      title: "Jobs",
      path: "/jobs",
    },
  ];
  return (
    <div>
      <BreadCrumps crumps={crumps} />
      {jobId && jobData.loading ? (
        <Loading />
      ) : (
        <div>
          <CreateForm
            isCreate={jobId ? false : true}
            title="Create a Job"
            onSubmit={handleFormSubmit}
            openToast={openToast}
            baseContentData={jobId ? jobData.data : {}}
            isLoading={operationStore.loading}
          />
        </div>
      )}
    </div>
  );
};
